<div class="server-errors">
  @if (errors) {
    @for (keypar of errors | keyvalue; track keypar.key) {
      @for (item of keypar.value; let i = $index; track i) {
        <p class="mb-1">{{ item }}</p>
      }
    }
  }
</div>
